module.exports = "/_next/static/images/neha-53456b986649f3f3c94d75cc6bee8bac.png";